module.exports = __webpack_public_path__ + "img/tx3.1924a8e3.png";